import {
  Background,
  BackgroundVariant,
  Controls,
  Node,
  ReactFlow,
  Edge,
  ReactFlowProps,
} from '@xyflow/react';
import styled from 'styled-components';
import { colorGray, colorPrimary } from '@atlas-frontend/design-tokens';

export type AlgorithmGraphProps<
  NodeType extends Node = Node,
  EdgeType extends Edge = Edge,
> = ReactFlowProps<NodeType, EdgeType>;

export const AlgorithmGraph = <
  NodeType extends Node = Node,
  EdgeType extends Edge = Edge,
>(
  props: AlgorithmGraphProps<NodeType, EdgeType>,
) => {
  const { children, ...rest } = props;
  return (
    <StyledReactFlow
      {...rest}
      proOptions={{ hideAttribution: true }}
      maxZoom={1}
      minZoom={0.5}
    >
      {children}
      <Controls position="bottom-right" />
      <Background color={colorGray[7]} variant={BackgroundVariant.Dots} />
    </StyledReactFlow>
  );
};

const StyledReactFlow: typeof ReactFlow = styled(ReactFlow)`
  .react-flow__node {
    z-index: -1 !important;
  }

  .react-flow__edge {
    &,
    &.selected,
    &.selectable:focus,
    &.selectable:focus-visible {
      .react-flow__edge-path {
        stroke: ${colorPrimary};
      }
    }

    &.selected,
    &.selectable:focus,
    &.selectable:focus-visible {
      .react-flow__edge-path {
        stroke-width: 2px;
      }
    }
  }
`;
